import { RG_TYPE as e } from "@project-rouge/rg-core";
import { getArea as t } from "../index3.js";
const p = (r) => t(r, [e.EmptySpace]);
export {
  p as getCommercialArea
};
//# sourceMappingURL=index11.js.map
